import { render, staticRenderFns } from "./oridisman.vue?vue&type=template&id=62c44c4a&scoped=true&"
import script from "./oridisman.vue?vue&type=script&lang=js&"
export * from "./oridisman.vue?vue&type=script&lang=js&"
import style0 from "./oridisman.vue?vue&type=style&index=0&id=62c44c4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c44c4a",
  null
  
)

export default component.exports